/* eslint-disable jsx-a11y/anchor-is-valid */
import { useCallback, useEffect, useState, useRef, memo } from 'react';
import clsx from 'clsx';
import Link from 'next/link';
import getLinkProps from '@/lib/getLinkProps';

import styles from './TagsRow.module.scss';

const TagsRow = memo(({ tags, parentId }) => {
	const [scrollState, setScrollState] = useState({
		fromStart: false,
		reachEnd: true,
	});
	const { fromStart, reachEnd } = scrollState;
	const tagsRef = useRef();

	const checkEnd = useCallback(() => {
		if (tagsRef.current) {
			const target = tagsRef.current;
			const { scrollWidth } = target;
			const { scrollLeft } = target;
			const targetWidth = target.offsetWidth;

			const nextFromStart = scrollLeft > 2;
			const nextReachEnd = scrollWidth - scrollLeft - targetWidth < 2;

			if (reachEnd !== nextReachEnd) {
				setScrollState(prev => ({ ...prev, reachEnd: nextReachEnd }));
			}

			if (fromStart !== nextFromStart) {
				setScrollState(prev => ({ ...prev, fromStart: nextFromStart }));
			}
		}
	}, [fromStart, reachEnd]);

	useEffect(() => {
		checkEnd();
	}, [checkEnd]);

	return (
		<div className={styles.row}>
			<ul
				className={clsx(
					styles.list,
					fromStart && styles.gradientLeft,
					!reachEnd && styles.gradientRight,
				)}
				ref={tagsRef}
			>
				{tags.map(tag => {
					const { name, slug } = tag;
					const [href, as] = getLinkProps({ type: 'catalog', value: slug });

					return (
						<li className={styles.item} key={slug}>
							<Link href={href} as={as} passHref>
								<a className={styles.link}>
									<span>{name}</span>
								</a>
							</Link>
						</li>
					);
				})}
			</ul>
		</div>
	);
});

export default TagsRow;
